<template>
  <v-card class="pa-5"  :style="{ border: '1px solid var(--primary-boarder-color)' }">
    <v-row class="pa-5 pb-0">
      <span class="text-h6 font-weight-medium">Privacy</span>
    </v-row>
    <v-row>
      <v-col>
        <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-avatar color="#def6ff" size="30" class="icon-box">
                  <v-icon small color="#00B3FF">double_arrow</v-icon>
                </v-avatar>
              </v-list-item-icon>
              <v-row>
                <v-col cols="12" class="detail-value"> <v-btn @click="changePassword" text color="#00B3FF" class="pa-0">Change Password</v-btn></v-col>
              </v-row>
            </v-list-item>
            <v-divider class="border-opacity-25"></v-divider>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  methods: {
    changePassword() {
      this.$emit('change-password-clicked');
    },
  },
};
</script>

<style scoped>
.icon-box {
  border-radius: 30%;
}

.detail-value {
  color: #000000;
  font-weight: 400;
  margin-top: 0px;
}
</style>
